<template>
  <div>
    <!-- <b-tabs>
      <b-tab
        v-for="file in files"
        :key="file.fileId"
        :title="file.fileName"
        lazy
        title-item-class="text-primary"
      >
        <template #title>{{file.fileName}}</template>

        <iframe :src="getViewerUrl(file)" frameborder="0" width="100%" :height="tableMaxHeight"></iframe>
      </b-tab>
    </b-tabs>-->

    <fieldset class="fieldset-layout">
      <legend class="legend-text legend-layout">
      
      </legend>
      <div style="min-height:500px;">
        <div v-if="fileType=='OTHER'">
          <a style="text-decoration:underline;cursor:pointer;" @click="downloadFile()">下载查看</a>
        </div>
        <div v-else>
          <iframe
            :src="viewerUrl"
            frameborder="0"
            width="100%"
            :height="tableMaxHeight"
            v-if="fileType!='IMG'"
          ></iframe>
          <div v-else>
            <b-container fluid class="p-4 bg-dark">
              <div class="pull-right">
                <b-button-toolbar key-nav aria-label="Toolbar with button groups">
                  <b-button-group class="mx-1">
                    <b-button @click="fan()">
                      <i class="fa fa-undo" aria-hidden="true"></i>
                    </b-button>
                    <b-button @click="zheng()">
                      <i class="fa fa-repeat" aria-hidden="true"></i>
                    </b-button>
                  </b-button-group>
                  <b-button-group class="mx-1">
                    <!-- <b-button :href="getOriginalFile()" target="_blank"><i class="fa fa-arrows-alt" aria-hidden="true"></i></b-button> -->
                  </b-button-group>
                </b-button-toolbar>
              </div>
              <div class="d-flex justify-content-center">
                <b-img
                  :src="fileUrl"
                  :style="{transform:'rotateZ('+deg+'deg)'}"
                  class="center-div"
                  fluid
                  alt="缩略图"
                ></b-img>
              </div>
            </b-container>
          </div>
        </div>
      </div>
    </fieldset>
    <!-- <template #tabs-end>
        <li role="presentation" class="nav-item align-self-center">
          <b-button v-b-toggle.sidebar-1 class="ml-2" variant="outline-primary">
            <b-icon icon="gear-fill" aria-hidden="true"></b-icon>
          </b-button>
        </li>
    </template>-->

    <loading :show="pageLoading"></loading>
  </div>
</template>

<script>
import {getFileInfo} from "@/api/tcs-upload-task-file-facade.js";

export default {
  data() {
    return {
      deg: 0,
  
      fileId: "",
      fileType: "",
      fileUrl: null,
      viewerUrl: "",
      tableMaxHeight: 500,
      pageLoading: false
    };
  },
  mounted() {
    window.onresize = () => {
      this.changeIFrameMaxHeight();
    };
    this.changeIFrameMaxHeight();
  },
  created() {
    
    this.fileId = this.$route.query.f;
   this.pageLoading=true;
    getFileInfo(this.fileId).then(res=>{
   //获取文件类型
    var file={};
    file.fileUrl=process.env.VUE_APP_FILE_DOWNLOAD_PREFIX+this.fileId;
   //file.fileUrl="http://localhost:8080/api/eids-invoice/file/obtain/e89651e3b4914a76a95b46d8e8cd369c";
    file.fileType=res.fileType;
    this.fileUrl=file.fileUrl;
    this.viewerUrl= this.getViewerUrl(file);
    this.pageLoading=false;
    });
    
  },
  computed: {},
  methods: {
    fan() {
      this.deg -= 90;
      if (this.deg >= 360) {
        this.deg = 0;
      }
    },
    // 图片正向旋转
    zheng() {
      this.deg += 90;
      if (this.deg >= 360) {
        this.deg = 0;
      }
    },
   
   
    // 自动更改iframe高度
    changeIFrameMaxHeight() {
      let height = document.body.offsetHeight; // 网页可视区域高度
      this.tableMaxHeight = height - 60;
      // console.log(this.tableMaxHeight)
    },

    // 获取iframe的显示地址
    getViewerUrl(file) {
      if (!file) {
        return "";
      }
      this.fileType = file.fileType;
      let viewerUrl;
      if (file.fileType == "OFD") {
        viewerUrl = "./ofd/index.html?file=";
      } else if (file.fileType == "PDF") {
        viewerUrl = "./pdf/web/viewer.html?file=";
      } else if (file.fileType == "IMG") {
        viewerUrl = "./#/imageViewer?file=";
        //return file;
      }

      return viewerUrl + encodeURIComponent(file.fileUrl);
    },
    downloadFile() {
      window.open(this.fileUrl, "_blank");
    }
  }
};
</script>

<style scoped>
</style>